import type { GetStaticProps, NextPage } from "next";
import Head from "next/head";
import { BlogList } from "components/molecules/BlogList";
import { BlogPage } from "components/organisms/BlogPage";
import { MDXFrontMatter } from "types";
import { getAllMdx } from "utils/mdx";
interface BlogsProps {
  blogs: Array<MDXFrontMatter>;
}
const Blogs: NextPage<BlogsProps> = ({
  blogs
}) => {
  return <>
            <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
                <title>
                    CharGen Blogs | Best AI Image Generator for RPG Art
                </title>
                <meta name="og:title" key="og:title" content="CharGen Blogs. Best AI Image Generator for RPG Art." data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta name="description" content="CharGen Blogs. Create AI Generated Images and learn how to use our AI Character Generator for D&D Character Art. Create stunning digital art for free with our DnD Character Creator." data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:url" key="og:url" content="https://char-gen.com/blogs" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:description" key="og:description" content="CharGen Blogs. Create AI Generated Images and learn how to use our AI Character Generator for D&D Character Art. Create stunning digital art for free with our DnD Character Creator." data-sentry-element="meta" data-sentry-source-file="index.tsx" />
            </Head>
            <BlogPage title="Blogs" description="Welcome to our blog! Here, we share tips and stories about Dungeons & Dragons, tabletop RPGs, and fantasy role-playing games. We also explore how AI art generation can enhance your characters and adventures." showBackLink={false} data-sentry-element="BlogPage" data-sentry-source-file="index.tsx">
                <BlogList blogs={blogs} data-sentry-element="BlogList" data-sentry-source-file="index.tsx" />
            </BlogPage>
        </>;
};
export const getStaticProps: GetStaticProps = async () => {
  const mdxFiles = getAllMdx().map(blog => blog ? blog["frontMatter"] as MDXFrontMatter : null);
  return {
    props: {
      blogs: mdxFiles
    }
  };
};
export default Blogs;